import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgRatingEmpty = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 24 24"
      ref={svgRef}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.427 3.776L14.78 8.5c.07.146.203.247.357.27l4.956.882c.39.059.545.564.262.85l-3.51 3.736a.518.518 0 00-.137.443l.766 5.236c.067.405-.338.716-.685.525l-4.565-2.328a.456.456 0 00-.437 0l-4.57 2.328c-.348.191-.752-.12-.685-.525l.776-5.239a.512.512 0 00-.138-.443l-3.524-3.732c-.284-.287-.13-.792.261-.85l4.954-.894a.473.473 0 00.356-.27l2.362-4.713a.464.464 0 01.848 0zM10.573 9.13c-.28.594-.836 1.016-1.446 1.106L5.99 10.8l2.25 2.381a2 2 0 01.552 1.716l-.49 3.309 2.769-1.411a1.938 1.938 0 011.835-.018l2.802 1.43-.48-3.285a2.005 2.005 0 01.524-1.712l2.26-2.406-3.095-.55a1.965 1.965 0 01-1.48-1.086L12 6.284 10.573 9.13z"
        clipRule="evenodd"
      />
    </svg>
  )
);
SvgRatingEmpty.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgRatingEmpty;
